import React from "react";
import Hero from "./Hero";

function JobListingsPage() {
  return (
    <>
      <Hero />
    </>
  );
}

export default JobListingsPage;
